import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {Helmet} from 'react-helmet';

import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import Routes from './Routes';
import I18n from './I18n';

const App = () => {
	return (
		<div>
			<Helmet>
				<meta charSet='utf-8' />
					<title>CoreCare | {I18n('home.phone_title')}</title>
					<link rel = 'canonical' href='https://www.ecordum.cn/' />
				<meta
					name = 'description'
					content = 'Wearable ECG sensors with wireless connection to iOS and Android devices. Up to 15 days of continuous Mobile Cardiac Telemetry without charging. Medical grade cardiac monitoring.'
				/>
			</Helmet>
			<Router>
				<Navbar />
				<ScrollToTop />
				<Routes />
				<Footer />
			</Router>
		</div>
	);
};

export default App;
